/* ============================================================
   productReviewOrderView (0aa086dd, audit-13 Card A) — pure view
   helpers for the Completed-order product-review forms: which
   order lines are reviewable shop products (deduped per product,
   quote-print lines without productId excluded).
   ============================================================ */

import type { OrderItem } from '../types/product';

export interface ProductReviewTarget {
  productId: string;
  title: string;
}

/**
 * Reviewable product lines of an order: seller-product lines only
 * (productId null = quote-print job), one target per distinct product
 * (first line's frozen title wins), original line order preserved.
 */
export function productReviewTargets(items: OrderItem[]): ProductReviewTarget[] {
  const seen = new Set<string>();
  const targets: ProductReviewTarget[] = [];
  for (const item of items) {
    if (!item.productId) continue;
    if (seen.has(item.productId)) continue;
    seen.add(item.productId);
    targets.push({ productId: item.productId, title: item.productTitle || 'Товар' });
  }
  return targets;
}
